<template>
  <div
    :style="{
      height: '100vh',
      overflow: 'hidden',
      margin: 'auto',
      position: 'relative',
    }"
  >
    <div
      v-if="!activeLink"
      :style="{
        height: '100vh',
        overflow: 'hidden',
        margin: 'auto',
        position: 'relative',
      }"
    >
      <img
        v-if="showAssetImage == 'default'"
        ref="imgRef"
        :src="apartmentImageSrc"
        alt=""
        :style="{
          width: '100%',
          height: '100%',
          margin: 'auto',
        }"
        @load="updateCanvasSize"
      />

      <img
        v-else
        ref="imgRef"
        :src="apartmenViewtImageSrc(showAssetImage)"
        alt=""
        :style="{
          width: '100%',
          height: '100%',
          display: 'block',
          margin: 'auto',
          objectFit: 'contain',
        }"
        @load="updateCanvasSize"
      />
    </div>
    <!-- Example: Four clickable points (adjust left/top as needed for your image) -->
    <div
      v-if="showAssetImage === 'default'"
      style="
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
      "
    >
      <div
        v-for="([key, point], idx) in Object.entries(clickablePoints)"
        :key="key"
        :style="{
          position: 'absolute',
          left: clickablePointsPx[idx].left + 'px',
          top: clickablePointsPx[idx].top + 'px',
          width: '60px',
          height: '60px',
          cursor: 'pointer',
          pointerEvents: 'auto',
          // background: 'black',
          zIndex: 2,
          transform: 'translate(-50%, -50%)',
        }"
        @click="() => setShowAssetImage(key)"
      ></div>
    </div>

    <canvas
      ref="canvasRef"
      :width="canvasSize.width"
      :height="canvasSize.height"
      :style="{
        position: 'absolute',
        top: imgOffsetTop,
        left: imgOffsetLeft,
        width: canvasSize.width + 'px',
        height: canvasSize.height + 'px',
        pointerEvents: 'auto',
      }"
    ></canvas>

    <button
      v-if="showAssetImage !== 'default'"
      @click="handleBackClick"
      style="
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 99999999;
        background: #f2efe6;
        color: #fff;
        border: none;
        padding: 6px 10px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        color: #333;
      "
    >
      Back
    </button>

    <div
      v-if="activeLink"
      style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1000;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
      "
    >
      <div
        style="
          position: relative;
          width: 100vw;
          height: 100vh;
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
        "
      >
        <button
          @click="handleBackClick"
          style="
            position: absolute;
            top: 10px;
            right: 10px;
            z-index: 99999999;
            background: #f2efe6;
            color: #fff;
            border: none;
            padding: 6px 10px;
            border-radius: 6px;
            cursor: pointer;
            font-size: 14px;
            color: #333;
          "
        >
          Back
        </button>
        <iframe
          :src="activeLink"
          style="width: 100%; height: 100%; border: none"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, onBeforeUnmount, watch, computed } from 'vue'
export default {
  props: {
    apiUrlEast: String,
    apiUrlEastMobile: String,
    apiUrlWest: String,
    apiUrlWestMobile: String,
    apiUrlNorth: String,
    apiUrlNorthMobile: String,
    apiUrlSouth: String,
    apiUrlSouthMobile: String,
  },
  setup(props) {
    const canvasRef = ref(null)
    const imgRef = ref(null)
    const activeLink = ref(null)
    const annotations = ref([])
    const canvasSize = reactive({ width: 0, height: 0 })
    const image = ref(null)
    const showAssetImage = ref('default')
    const dropdownAnnotationId = ref(null)
    const dropdownPosition = ref(null)
    const innerWidth = window.innerWidth
    const clickablePoints = {
      West: { x: 36, y: 50 },
      East: { x: 63, y: 50 },
      North: { x: 50, y: 22 },
      South: { x: 50, y: 76 },
    }
    const clickableMobilePoints = {
      West: { x: 18, y: 48 },
      East: { x: 80, y: 48 },
      North: { x: 50, y: 29 },
      South: { x: 50, y: 66 },
    }
    const clickableTabletPoints = {
      West: { x: 36, y: 50 },
      East: { x: 63, y: 50 },
      North: { x: 50, y: 5 },
      South: { x: 50, y: 95 },
    }
    const imgOffsetTop = ref('0px')
    const imgOffsetLeft = ref('0px')
    const isMobile = ref(window.innerWidth <= 768)
    const isTablet = ref(window.innerWidth > 768 && window.innerWidth <= 1024)
    const apartmentImageSrc = computed(() =>
      isMobile.value
        ? '/img/ui-theme/mobile-retreat-apartment.jpg'
        : '/img/ui-theme/retreat-apartment.png'
    )

    const apartmenViewtImageSrc = (key) => {
      return isMobile.value
        ? `/img/ui-theme/${key}Mobile.png`
        : `/img/ui-theme/${key}.png`
    }

    const assetWidth = computed(() => isMobile.value)
    // Listen for resize to update isMobile
    window.addEventListener('resize', () => {
      isMobile.value = window.innerWidth <= 768
      isTablet.value = window.innerWidth > 768 && window.innerWidth <= 1024
    })
    const statusImages = {
      completed: '/img/ui-theme/sold.png',
      pending: '/img/ui-theme/hold.png',
      requested: '/img/ui-theme/available.svg',
      default: '/img/ui-theme/default.png',
    }

    const loadedImages = ref({})
    let preloadPromise = null

    const fetchAnnotations = async () => {
      if (!props[`apiUrl${showAssetImage.value}`]) return
      const annotationUrl = !isMobile.value
        ? `apiUrl${showAssetImage.value}`
        : `apiUrl${showAssetImage.value}Mobile`
      try {
        const res = await fetch(props[annotationUrl])
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`)
        const data = await res.json()
        annotations.value = Array.isArray(data?.data?.data)
          ? data.data.data
          : []
      } catch (err) {
        annotations.value = []
      }
    }
    const clickablePointsPx = computed(() => {
      const width = canvasSize.width
      const height = canvasSize.height
      const offsetLeft = parseInt(imgOffsetLeft.value)
      const offsetTop = parseInt(imgOffsetTop.value)
      if (isMobile.value) {
        return Object.values(clickableMobilePoints).map((pt) => ({
          left: offsetLeft + (pt.x / 100) * width,
          top: offsetTop + (pt.y / 100) * height,
        }))
      } else if (isTablet.value) {
        return Object.values(clickableTabletPoints).map((pt) => ({
          left: offsetLeft + (pt.x / 100) * width,
          top: offsetTop + (pt.y / 100) * height,
        }))
      } else {
        return Object.values(clickablePoints).map((pt) => ({
          left: offsetLeft + (pt.x / 100) * width,
          top: offsetTop + (pt.y / 100) * height,
        }))
      }
    })
    const updateCanvasSize = () => {
      if (!imgRef.value) return
      const img = imgRef.value

      // Wait for the image to be fully loaded
      if (!img.complete || img.naturalWidth === 0 || img.naturalHeight === 0) {
        return
      }
      // Get container size
      const container = img.parentElement
      const containerRect = container.getBoundingClientRect()
      const containerWidth = containerRect.width
      const containerHeight = containerRect.height

      // Get image's natural size and aspect ratio
      const naturalWidth = img.naturalWidth
      const naturalHeight = img.naturalHeight
      const imgAspect = naturalWidth / naturalHeight
      const containerAspect = containerWidth / containerHeight

      let displayWidth, displayHeight, offsetLeft, offsetTop

      if (imgAspect > containerAspect) {
        // Image fills width, height is auto
        displayWidth = containerWidth
        displayHeight = containerWidth / imgAspect
        offsetLeft = 0
        offsetTop = (containerHeight - displayHeight) / 2
      } else {
        // Image fills height, width is auto
        displayHeight = containerHeight
        displayWidth = containerHeight * imgAspect
        offsetTop = 0
        offsetLeft = (containerWidth - displayWidth) / 2
      }

      // Update canvas size (round to avoid fractional pixels)
      canvasSize.width = Math.round(displayWidth)
      canvasSize.height = Math.round(displayHeight)

      // Store offsets for canvas positioning
      imgOffsetLeft.value = Math.round(offsetLeft) + 'px'
      imgOffsetTop.value = Math.round(offsetTop) + 'px'

      // Force canvas redraw after size update
      requestAnimationFrame(() => {
        drawCanvas()
      })
    }

    const preloadImages = () => {
      if (preloadPromise) return preloadPromise
      preloadPromise = Promise.all(
        Object.entries(statusImages).map(([key, src]) => {
          return new Promise((resolve) => {
            const img = new window.Image()
            img.src = src
            img.onload = () => {
              loadedImages.value[key] = img
              resolve()
            }
            img.onerror = () => resolve()
          })
        })
      )
      return preloadPromise
    }

    const drawCanvas = async () => {
      if (!canvasRef.value || showAssetImage.value == 'default') return
      const canvas = canvasRef.value
      const ctx = canvas.getContext('2d')
      const dpr = window.devicePixelRatio || 1
      const displayWidth = canvasSize.width
      const displayHeight = canvasSize.height

      if (displayWidth === 0 || displayHeight === 0) return

      // Set up high-DPI canvas
      canvas.width = displayWidth * dpr
      canvas.height = displayHeight * dpr
      canvas.style.width = displayWidth + 'px'
      canvas.style.height = displayHeight + 'px'
      ctx.scale(dpr, dpr)
      ctx.clearRect(0, 0, displayWidth, displayHeight)
      ctx.imageSmoothingEnabled = true
      ctx.imageSmoothingQuality = 'high'

      // Pill size
      const basePillSize =
        window.innerWidth <= 768 ? 12 : window.innerWidth <= 1024 ? 18 : 28
      const pillDisplaySize = basePillSize

      annotations.value.forEach((annotation) => {
        const shape = annotation.attributes.shape
        if (!shape || shape.x === undefined || shape.y === undefined) return

        const scaleX = displayWidth / shape.originalWidth
        const scaleY = displayHeight / shape.originalHeight

        // Scale annotation coordinates
        const scaledX = shape.x * scaleX
        const scaledY = shape.y * scaleY
        const scaledWidth = shape.width * scaleX
        const scaledHeight = shape.height * scaleY

        // Normalize coordinates for negative widths/heights
        const rectX = scaledWidth < 0 ? scaledX + scaledWidth : scaledX
        const rectY = scaledHeight < 0 ? scaledY + scaledHeight : scaledY
        const rectWidth = Math.abs(scaledWidth)
        const rectHeight = Math.abs(scaledHeight)

        // Load pill image based on status
        const pillImage = loadedImages.value[annotation.attributes.status]
        if (!pillImage) return

        // ✅ Calculate pill position relative to blue box top-right
        const pillX = rectX + rectWidth - pillDisplaySize / 2
        const pillY = rectY - pillDisplaySize / 2

        ctx.save()

        // Draw pill as a circle
        ctx.beginPath()
        ctx.arc(
          pillX + pillDisplaySize / 2,
          pillY + pillDisplaySize / 2,
          pillDisplaySize / 2,
          0,
          2 * Math.PI
        )
        ctx.closePath()
        ctx.clip()

        ctx.drawImage(pillImage, pillX, pillY, pillDisplaySize, pillDisplaySize)

        ctx.restore()
      })
    }

    function isPointInShape(shape, displayWidth, displayHeight, x, y) {
      const scaleX = displayWidth / shape.originalWidth
      const scaleY = displayHeight / shape.originalHeight

      let scaledX1 = shape.x * scaleX
      let scaledX2 = (shape.x + shape.width) * scaleX
      let scaledY1 = shape.y * scaleY
      let scaledY2 = (shape.y + shape.height) * scaleY

      if (shape.width < 0) [scaledX1, scaledX2] = [scaledX2, scaledX1]
      if (shape.height < 0) [scaledY1, scaledY2] = [scaledY2, scaledY1]

      return x >= scaledX1 && x <= scaledX2 && y >= scaledY1 && y <= scaledY2
    }
    const handleClick = (e) => {
      const canvas = canvasRef.value
      if (!canvas || !canvasSize.width || !canvasSize.height) return

      const rect = canvas.getBoundingClientRect()
      const clickX = e.clientX - rect.left
      const clickY = e.clientY - rect.top

      for (const annotation of annotations.value) {
        const shape = annotation.attributes?.shape
        if (!shape) continue

        if (
          isPointInShape(
            shape,
            canvasSize.width,
            canvasSize.height,
            clickX,
            clickY
          )
        ) {
          const urlPattern = /(?:https?:\/\/|www\.)[\w.-]+(?:\/[^\s]*)?/g
          const extractedLinks = annotation.attributes.note.match(urlPattern)

          if (extractedLinks && extractedLinks.length > 0) {
            activeLink.value = extractedLinks[0]
            document.getElementsByClassName(
              'btn-close-asset'
            )[0].style.display = 'none'
          }
          break
        }
      }
    }
    const setShowAssetImage = (key) => {
      showAssetImage.value = key
      if (key !== 'default') {
        document.getElementsByClassName('btn-close-asset')[0].style.display =
          'none'
      } else {
        const canvas = canvasRef.value
        const ctx = canvas.getContext('2d')
        const displayWidth = canvasSize.width
        const displayHeight = canvasSize.height
        ctx.clearRect(0, 0, displayWidth, displayHeight)
        annotations.value = []
        document.getElementsByClassName('btn-close-asset')[0].style.display =
          'flex'
      }
    }

    const handleBackClick = () => {
      if (activeLink.value) {
        activeLink.value = null
      } else {
        setShowAssetImage('default')
      }
    }

    const closeDropdown = () => (dropdownAnnotationId.value = null)

    onMounted(() => {
      preloadImages()
      fetchAnnotations()

      window.addEventListener('resize', updateCanvasSize)
      window.addEventListener('click', handleClick)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateCanvasSize)
      window.removeEventListener('click', handleClick)
    })

    watch([showAssetImage], () => {
      fetchAnnotations()
    })

    watch([annotations], () => {
      drawCanvas()
    })

    watch(
      () => props.imageUrl,
      (newUrl) => {
        if (!newUrl) return
        const img = new Image()
        img.onload = () => (image.value = img)
        img.src = newUrl
      }
    )

    return {
      canvasRef,
      imgRef,
      canvasSize,
      showAssetImage,
      dropdownAnnotationId,
      dropdownPosition,
      imgOffsetTop,
      imgOffsetLeft,
      activeLink,
      clickablePoints,
      apartmentImageSrc,
      assetWidth,
      innerWidth,
      closeDropdown,
      updateCanvasSize,
      handleBackClick,
      clickablePointsPx,
      setShowAssetImage,
      apartmenViewtImageSrc,
    }
  },
}
</script>
